/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */

export const REQUESTED_ASSET_ALLOCATION = 'REQUESTED_ASSET_ALLOCATION';
export const requestedAssetAllocation = () => ({
  type: REQUESTED_ASSET_ALLOCATION
});

export const RECEIVED_ASSET_ALLOCATION = 'RECEIVED_ASSET_ALLOCATION';
export const receivedAssetAllocation = (assetAllocation) => ({
  type: RECEIVED_ASSET_ALLOCATION,
  assetAllocation
});

export const ERROR_ASSET_ALLOCATION = 'ERROR_ASSET_ALLOCATION';
export const errorAssetAllocation = (error) => ({
  type: ERROR_ASSET_ALLOCATION,
  error
});
